import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
// import { PropTypes } from 'prop-types';

import './utils/ValidationRules';

// Accounts management components
import AccountsApp from './components/AccountsApp';

// User management components
import Login from './pages/Login';

// Routing components
import IndexRedirect from './utils/routing/IndexRedirect';
import PrivateRoute from './utils/routing/PrivateRoute';

// CSS inclusion for whole app
import './components/App.css';
import 'normalize.css/normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'nvd3/build/nv.d3.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

import App from './components/App';

import config from '../../config.json';

class Root extends Component {

    // We need to provide a list of routes
    // for our app, and in this case we are
    // doing so from a Root component

    render() {
        const namespace = config.namespace.length ? config.namespace : '/';
        return (
          <BrowserRouter
            basename={namespace}
          >
            <div>
              <Route exact path="/" component={IndexRedirect}/>
              <Route path="/login" component={Login}/>
              <PrivateRoute path="/users" admin={false} component={App}/>
              <PrivateRoute
                path="/accounts"
                admin={true}
                component={AccountsApp}
              />
            </div>
          </BrowserRouter>
        );
    }
}

export default Root;



/** WEBPACK FOOTER **
 ** ./src/Root.js
 **/